import { runtimeEnv } from "config/runtimeEnv";
import { setCurrentUser } from "utils/utils";
import { API_ENDPOINT } from "./Api";
import requestInstance from "./Request";

let env = runtimeEnv("B2B_API_BASE_URL");

//Emplyees service
export const getEmployeeListService = async (data) => {
  const payloadData = {
    search: data?.search || "",
    companyId: data?.companyId || "",
    page: data?.page === 0 || data?.page ? data?.page + 1 : 1,
    pageSize: data?.pageSize || "",
  };

  const res = await requestInstance
    .get(
      `${env}${API_ENDPOINT.Employee.api}/?companyId=${payloadData?.companyId}&search=${payloadData?.search}&page=${payloadData?.page}&pageSize=${payloadData?.pageSize}`,
    )
    .catch((err) => err.response);
  return setCurrentUser(res);
};

export const getEmployeeDetailsService = async (payload) => {
  const res = await requestInstance
    .get(`${env}${API_ENDPOINT.Profile.api}?id=${payload}`)
    .catch((err) => err.response);
  return setCurrentUser(res);
};

export const addEmployeeService = async (data) => {
  const res = await requestInstance
    .post(`${env}${API_ENDPOINT.Employee.api}`, data)
    .catch((err) => err.response);
  return setCurrentUser(res);
};

export const updateEmployeeService = async (data, id) => {
  const res = await requestInstance
    .patch(`${env}${API_ENDPOINT.Employee.patchApi}/${id}`, data)
    .catch((err) => err.response);
  return setCurrentUser(res);
};

export const uploadEmployeeExcelService = async (data) => {
  const formData = new FormData();

  formData.append("companyId", data?.companyId);
  formData.append("file", data?.file);

  const res = await requestInstance
    .post(`${env}${API_ENDPOINT.Employee.uploadExcelApi}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .catch((err) => err.response);

  return setCurrentUser(res);
};

export const approveEmployeeService = async (data) => {
  const res = await requestInstance
    .patch(`${env}${API_ENDPOINT.Employee.approveEmployeeApi}`, data)
    .catch((err) => err.response);

  return setCurrentUser(res);
};
